<template>
    <div>
        <v-container style="max-width:1000px">
            <h1 style="text-align:center">Välj datum</h1>
            <v-container>
                <v-row>
                    <v-col>
                        <v-date-picker
                            v-model="date"
                            locale="sv"
                            :show-current="true"
                            :min="
                                nowDate
                            "
                        >
                        </v-date-picker
                        ><br />
                    </v-col>
                    <v-col>
                        <v-container v-for="(date, i) in dates" :key="i">
                            <v-row>
                                <div class="daybox">
                                    <p class="month">{{ toMonth(date) }}</p>
                                    <p class="day">{{ toDay(date) }}</p>
                                </div>
                                <div>
                                <div class="selectbox">
                                    <v-select
                                    v-model="stime[i]"
                                    :items="items"
                                    label="Starttid"
                                    ></v-select>
                                    <v-select
                                    v-model="ftime[i]"
                                    :items="items"
                                    label="Sluttid"
                                    @input="setTime(date, i)"
                                    ></v-select>
                                    <v-btn @click="removeDate(i)" text
                                    ><v-icon small color="red">fas fa-trash</v-icon></v-btn>
                                </div>
                                <div class="addbtn">
                                    <v-btn
                                    v-show="dates.indexOf(dates[i]) == i"
                                    @click="add(date)"
                                    text
                                    small
                                    >Lägg till tid</v-btn></div>
                                    </div>
                                <!-- <v-menu
                                    ref="menu"
                                    v-model="menu2[i]"
                                    :close-on-content-click="false"
                                    :return-value.sync="time"
                                    transition="scale-transition"
                                    offset-y
                                    max-width="1000px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="time"
                                            :label="
                                                ftime[i]
                                                    ? `${stime[i]}-${ftime[i]}`
                                                    : 'Välj tid'
                                            "
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <div style="display:flex;">
                                        <v-time-picker
                                            v-if="menu2[i]"
                                            v-model="stime[i]"
                                            format="24hr"
                                            :allowed-minutes="allowedMinutes"
                                        ></v-time-picker>
                                        <v-time-picker
                                            v-if="menu2[i]"
                                            v-model="ftime[i]"
                                            format="24hr"
                                            :allowed-minutes="allowedMinutes"
                                            :min="stime[i]"
                                        ></v-time-picker>
                                        <v-btn @click="setTime(date, i)" text
                                            ><v-icon>fas fa-plus</v-icon></v-btn
                                        >
                                    </div>
                                </v-menu> -->

                                <!--                                <input
                                    v-model="stime[i]"
                                    type="time"
                                    class="inputtime"
                                />
                                <input
                                    v-model="ftime[i]"
                                    type="time"
                                    class="inputtime"
                                />-->

                                
                                
                            </v-row>
                        </v-container>
                    </v-col>
                </v-row>
                <div>
                    <v-row
                        ><v-switch
                            v-model="replyDeadline"
                            label="Sätt en deadline för svar"/>
                            <!-- <input
                            class="input"
                            v-model="replyDate"
                            v-show="replyDeadline"
                            type="date"
                    /> -->
                    <!-- <v-date-picker
                            v-model="replyDate"
                            locale="sv"
                            v-show="replyDeadline"
                            :min="nowDate"
                        >
                        </v-date-picker
                        > -->
                        <v-col cols="12" sm="6" md="4">
                        <v-menu
        v-model="menu2s"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="computedDateFormatted"
            readonly
            v-bind="attrs"
            v-on="on"
        v-show="replyDeadline"
          ></v-text-field>
        </template>
        <v-date-picker v-model="replyDate" locale="sv" :min="nowDate" @input="menu2s = false"></v-date-picker>
      </v-menu>
      </v-col>
                    </v-row>
                    <v-row>
                        <v-switch
                            v-model="ifNeeded"
                            label="Lägg till
                        alternativet 'Om det behövs' för att fånga upp även
                        halvbra tidsförslag."
                        />
                    </v-row>
                    <v-row>
                        <v-checkbox
                            v-model="oneAns"
                            label="Begränsa till ett svar"
                        />
                        <v-checkbox v-model="hidSchedule" label="Endast åtkomst för Admin" />
                    </v-row>
                    <v-row>
                        <v-checkbox
                            v-model="contactInfo"
                            label="Be om kontaktinformation"
                        />
                    </v-row>
                    <v-row v-if="contactInfo">
                        <v-checkbox
                            label="E-post"
                            readonly
                            v-model="echeck"
                        />
                        <v-checkbox
                            label="Mobil"
                            readonly
                            v-model="pcheck"
                        />
                        </v-row>
                    <v-row v-if="contactInfo" class="contact">
                        <v-text-field label="Annan valfri information 1" v-model="ci0" />
                        <v-text-field label="Annan valfri information 2" v-model="ci1" />
                        <v-text-field label="Annan valfri information 3" v-model="ci2" />
                        <v-text-field label="Annan valfri information 4" v-model="ci3" />
                        <v-text-field label="Annan valfri information 5" v-model="ci4" />
                    </v-row>
                    <v-row>
                        <v-switch
                            v-model="adminOnly"
                            label="Publicera tid på omröstningssidan"
                        />
                    </v-row>
                </div>
                <v-btn
                    @click="back"
                    style="background-color:#ffa500;margin-right:3px"
                    ><v-icon style="font-size:15px;margin-left:3px"
                        >fas fa-arrow-left</v-icon
                    >Tillbaka
                </v-btn>
                <v-btn @click="submit" style="background-color:#ffa500"
                    >Skicka in
                    <v-icon style="font-size:15px;margin-left:3px"
                        >fas fa-check</v-icon
                    ></v-btn
                >
            </v-container>
            <v-dialog v-model="adddialog" width="500">
                <v-alert>
                    Tiden har lagts till
                    <v-divider></v-divider>
                    <v-btn color="primary" text @click="adddialog = false">
                        Ok
                    </v-btn>
                </v-alert>
            </v-dialog>
            <v-dialog v-model="rmdialog" width="500">
                <v-alert>
                    Tid borttagen
                    <v-divider></v-divider>
                    <v-btn color="primary" text @click="rmdialog = false">
                        Ok
                    </v-btn>
                </v-alert>
            </v-dialog>
            <v-dialog v-model="addtime" width="500">
                <v-alert>
                    Du måste välja minst en datum och tidpunkt.
                    <v-divider></v-divider>
                    <v-btn color="primary" text @click="addtime = false">
                        Ok
                    </v-btn>
                </v-alert>
            </v-dialog>
        </v-container>
    </div>
</template>

<script>
import store from "../../../store";
export default {
    data: () => ({
        store: store,
        name: "Step2",
        dateNow: "",
        date: null,
        month: ['Jan','Feb','Mar','Apr','Maj','Jun','Jul','Aug','Sep','Okt','Nov','Dec'],
        items: ['00:00', '00:15', '00:30', '00:45','01:00', '01:15', '01:30', '01:45','02:00', '02:15', '02:30', '02:45',
        '03:00', '03:15', '03:30', '03:45','04:00', '04:15', '04:30', '04:45','05:00', '05:15', '05:30', '05:45',
        '06:00', '06:15', '06:30', '06:45','07:00', '07:15', '07:30', '07:45','08:00', '08:15', '08:30', '08:45',
        '09:00', '09:15', '09:30', '09:45','10:00', '10:15', '10:30', '10:45','11:00', '11:15', '11:30', '11:45',
        '12:00', '12:15', '12:30', '12:45','13:00', '13:15', '13:30', '13:45','14:00', '14:15', '14:30', '14:45',
        '15:00', '15:15', '15:30', '15:45','16:00', '16:15', '16:30', '16:45','17:00', '17:15', '17:30', '17:45',
        '18:00', '18:15', '18:30', '18:45','19:00', '19:15', '19:30', '19:45','20:00','20:15', '20:30', '20:45',
        '21:00','21:15', '21:30', '21:45','22:00', '22:15', '22:30', '22:45','23:00', '23:15', '23:30', '23:45'],
        dates: [],
        schedule: [],
        time: [],
        times: [],
        menu: [],
        stime: [],
        ftime: [],
        menu2: [],
        menu2s: false,
        adddialog: false,
        rmdialog: false,
        addtime: false,
        echeck: true,
        pcheck: true,
        replyDeadline: store.state.schedule.replyDeadline,
        ifNeeded: store.state.schedule.ifNeeded,
        oneAns: store.state.schedule.oneAns,
        hidSchedule: store.state.schedule.hidSchedule,
        contactInfo: store.state.schedule.contactInfo,
        adminOnly: store.state.schedule.adminOnly,
        config: {},
        replyDate: store.state.schedule.replyDate,
        disabledDates: new Date(Date.now() - 8640000),
        nowDate: new Date().toISOString().slice(0,10),
        ci0: undefined,
        ci1: undefined,
        ci2: undefined,
        ci3: undefined
    }),
    watch: {
        date: function() {
            this.add(this.date);
            // console.log(val);
        }
    },
    created: function() {
        let date = new Date();
        this.dateNow = `${date.getFullYear()}-0${date.getMonth()}-${date.getDate()}`;

    },
    computed: {
      computedDateFormatted () {
        return this.formatDate(this.replyDate)
      },
    },
    methods: {
        allowedMinutes: v => v % 5 == 0,
        next: async function() {
            this.config = {
                schedule: this.store.state.schedule.time,
                replyDeadline: this.replyDeadline,
                ifNeeded: this.ifNeeded,
                oneAns: this.oneAns,
                hidSchedule: this.hidSchedule,
                contactInfo: this.contactInfo,
                adminOnly: this.adminOnly,
                replyDate: this.replyDate,
                ci0: this.ci0,
                ci1: this.ci1,
                ci2: this.ci2,
                ci3: this.ci3,
                ci4: this.ci4
            };
            if (this.dates.length === 0) {
                this.store.state.alertMsg = "Du måste välja minst en tidpunkt.";
                this.store.state.showAlert = true;
                this.store.state.alertType = "error";
                return;
            }
            await this.store.dispatch("step2", this.config);
            this.store.state.e1++;
        },
        add: function(date) {
            if (date === null) return;
            this.dates[this.dates.length] = date;
            this.$forceUpdate()
            // this.menu[this.dates.length] = false;
            // this.menu2.push(false);
            console.log(this.dates)
        },
        setTime: function(indate, i) {
            let date = {
                date: indate,
                stime: this.stime[i],
                ftime: this.ftime[i]
            };
            let j = this.store.state.schedule.time.length;
            this.store.state.schedule.time[j] = date;
            // alert(this.stime[i])
            // alert(this.ftime[i])
            // if(){
            //     return
            // }
            // this.adddialog = true;
        },
        removeDate: function(date) {
            this.dates.splice(date, 1);
            this.store.state.schedule.time.splice(date, 1);
            this.menu2.splice(date);
            // this.rmdialog = true;
        },
        back: function() {
            this.store.state.e1--;
        },
        toDDMMYY(date) {
            let dated = new Date(date);
            return `${dated.getDate()}/${dated.getMonth() +
                1}/${dated.getFullYear()}`;
        },
        toDay(date) {
            let dated = new Date(date);
            return `${dated.getDate()}`;
        },
        toMonth(date) {
            let dated = new Date(date);
            return `${this.month[dated.getMonth()]}`;
        },
        submit: async function() {
            if (this.dates.length === 0) {
                this.store.state.alertMsg = "Du måste välja minst en tidpunkt.";
                this.store.state.alertType = "error";
                this.store.state.showAlert = true;
                this.addtime = true;
                return;
            }else if(this.ftime.length === 0){
                this.addtime = true;
                return;
            }
            this.store.state.loading = true;
            this.config = {
                schedule: this.store.state.schedule.time,
                replyDeadline: this.replyDeadline,
                ifNeeded: this.ifNeeded,
                oneAns: this.oneAns,
                hidSchedule: this.hidSchedule,
                contactInfo: this.contactInfo,
                adminOnly: this.adminOnly,
                replyDate: this.replyDate,
                ci0: this.ci0,
                ci1: this.ci1,
                ci2: this.ci2,
                ci3: this.ci3,
                ci4: this.ci4
            };
            await this.store.dispatch("step2", this.config);
            let bodyFormData = new FormData();
            bodyFormData.append("user_id", this.store.state.user.id);
            bodyFormData.append(
                "time",
                JSON.stringify(this.store.state.schedule.time)
            );
            if (this.store.state.schedule.ifNeeded)
                bodyFormData.append("ifNeeded", "yes");
            else bodyFormData.append("ifNeeded", "no");
            if (this.store.state.schedule.deadlineReply) {
                bodyFormData.append("deadlineReply", "yes");
                bodyFormData.append(
                    "deadlineDate",
                    this.store.state.schedule.deadlineDate
                );
            } else bodyFormData.append("deadlineReply", "no");

            if (this.store.state.schedule.oneAns)
                bodyFormData.append("oneAns", "yes");
            else bodyFormData.append("oneAns", "no");
            if (this.store.state.schedule.hidSchedule)
                bodyFormData.append("hidSchedule", "yes");
            else bodyFormData.append("hidSchedule", "no");
            if (this.store.state.schedule.adminOnly)
                bodyFormData.append("adminOnly", "yes");
            else bodyFormData.append("adminOnly", "no");
            bodyFormData.append("title", this.store.state.schedule.title);
            if (this.store.state.schedule.contactInfo)
                bodyFormData.append("contactInfo", "yes");
            else bodyFormData.append("contactInfo", "no");
            bodyFormData.append(
                "description",
                this.store.state.schedule.description
            );
            bodyFormData.append("location", this.store.state.schedule.location);
            bodyFormData.append("theme", this.store.state.schedule.theme);
            bodyFormData.append("username", this.store.state.schedule.username);
            bodyFormData.append(
                "customtheme",
                this.store.state.schedule.customtheme
            );
            bodyFormData.append("ci0", this.store.state.ci0);
            bodyFormData.append("ci1", this.store.state.ci1);
            bodyFormData.append("ci2", this.store.state.ci2);
            bodyFormData.append("ci3", this.store.state.ci3);
            bodyFormData.append("ci4", this.store.state.ci4);
            var config = {
                method: "post",
                headers: {
                    "Content-Type": "application/form-data;charset=utf-8",
                    "Access-Control-Allow-Origin": "*",
                    Accept: "*/*"
                },
                data: bodyFormData
            };
            await this.store.dispatch("createEvent", config);
            this.store.state.loading = false;
            this.$router.replace(`/schedule/${this.store.state.link}`);
        },
        formatDate (date) {
        if (!date) return null
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      }
    }
};
</script>

<style scopped>
.input {
    margin-left: 10px;
    max-height: 40px;
    margin-top: 10px;
    border: 2px solid black;
}
.inputtime {
    margin-left: 10px;
    max-height: 45px;
    border: 2px solid black;
}
.daybox {
    background-color: #ffa500;
    border-radius: 6px;
    padding: 0px 10px;
    text-align: center;
    color: #fff;
    height: 75px;
}
.day {
    margin: 5px 0px !important;
    font-weight: 700 !important;
    font-size: 1.25rem !important;
}
.month {
    margin: 5px 0px !important;
}
.selectbox {
    display: flex;
    justify-content: flex-start;
    margin: 0px 20px;
}
.selectbox .v-input {
    width: 100px !important;
}
.addbtn {
    margin: 0px 40px;
}
.contact {
    display: block;
}
</style>
